var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlowbiteUserRemoveOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 13.9987H23.3334M4.66675 20.9987V19.832C4.66675 18.9038 5.0355 18.0135 5.69187 17.3572C6.34825 16.7008 7.23849 16.332 8.16675 16.332H12.8334C13.7617 16.332 14.6519 16.7008 15.3083 17.3572C15.9647 18.0135 16.3334 18.9038 16.3334 19.832V20.9987C16.3334 21.6987 15.8667 22.1654 15.1667 22.1654H5.83341C5.524 22.1654 5.22725 22.0424 5.00846 21.8237C4.78966 21.6049 4.66675 21.3081 4.66675 20.9987ZM14.0001 9.33203C14.0001 10.2603 13.6313 11.1505 12.975 11.8069C12.3186 12.4633 11.4283 12.832 10.5001 12.832C9.57182 12.832 8.68158 12.4633 8.02521 11.8069C7.36883 11.1505 7.00008 10.2603 7.00008 9.33203C7.00008 8.40377 7.36883 7.51353 8.02521 6.85716C8.68158 6.20078 9.57182 5.83203 10.5001 5.83203C11.4283 5.83203 12.3186 6.20078 12.975 6.85716C13.6313 7.51353 14.0001 8.40377 14.0001 9.33203Z",
    stroke: "#961F16",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowbiteUserRemoveOutline);
export default __webpack_public_path__ + "static/media/flowbite_user-remove-outline.0806e22a8d0d276f9e444bfe90cc752d.svg";
export { ForwardRef as ReactComponent };